import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function CTA() {
  return <section id="contacto" className="scroll-mt-24 px-6 py-24 lg:px-10 lg:py-32" data-id="element-13" data-mp="1lfzwwyez3tn6">
      <Reveal data-id="element-14" data-mp="1zh2jdc9vr5ym">
        <div className="relative mx-auto max-w-7xl overflow-hidden rounded-4xl bg-gradient-to-br from-accent via-[#1E4FD8] to-ink px-8 py-16 text-center shadow-lift lg:px-16 lg:py-24" data-id="element-15" data-mp="1zfrgdeo9e28k">
          <div aria-hidden="true" className="pointer-events-none absolute -top-24 left-1/2 h-72 w-72 -translate-x-1/2 rounded-full bg-white/10 blur-3xl" data-id="element-16" data-mp="16rdicyx675x0" />
          <h2 className="relative mx-auto max-w-3xl text-4xl font-semibold leading-[1.08] tracking-[-0.03em] text-white lg:text-6xl" data-id="element-17" data-mp="1gigj1zm6tivr">
            ¿Listo para impulsar tu próximo proyecto?
          </h2>
          <p className="relative mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-white/80" data-id="element-18" data-mp="o147l0nbi5tp">
            Trabajemos juntos para crear soluciones digitales que marquen la diferencia.
          </p>
          <a href="mailto:hola@almaria.com" className="group relative mt-10 inline-flex items-center gap-2.5 rounded-full bg-white px-8 py-4 text-base font-medium text-ink shadow-lift transition-all duration-200 hover:-translate-y-0.5 hover:bg-canvas" data-id="element-19" data-mp="33ewmba55ojrq">
            Contactar ahora
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-20" data-mp="3h4qeo2fvdm67" />
          </a>
        </div>
      </Reveal>
    </section>;
}